import { Avatar, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import type { IProjectSourceSocialOrder } from '../../api/types/projects'
import { routesProfile } from '../../consts'

type Props = {
  sourceSocialOrder: IProjectSourceSocialOrder | null | undefined
}

export const SourceSocialOrderSection = ({ sourceSocialOrder }: Props) => {
  const navigate = useNavigate()

  if (!sourceSocialOrder) {
    return null
  }

  const pathKey = sourceSocialOrder.slug || sourceSocialOrder.id

  return (
    <Stack gap={1.5}>
      <Typography variant="black-14-medium">Социальный заказ</Typography>
      <Stack
        direction="row"
        gap={1.25}
        alignItems="center"
        sx={{ cursor: 'pointer', width: '100%' }}
        onClick={() => navigate(`/${routesProfile.SOCIALORDERS.path}/${pathKey}`)}
      >
        <Avatar
          src={sourceSocialOrder.image ?? undefined}
          alt={sourceSocialOrder.title}
          sx={{ width: 36, height: 36 }}
        >
          {sourceSocialOrder.title.trim().charAt(0) || '?'}
        </Avatar>
        <Stack minWidth={0}>
          <Typography variant="black-12-light" noWrap>
            {sourceSocialOrder.title}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  )
}
